import {
  FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs,
  FaPython, FaGitAlt, FaGithub, FaBootstrap, FaCode, FaMobile,
} from 'react-icons/fa';
import { SiTailwindcss, SiMongodb, SiMysql, SiDotnet } from 'react-icons/si';
import { SiTypescript, SiPostman, SiSwagger, SiGitlab } from 'react-icons/si';
import { SiAnthropic, SiOpenai } from 'react-icons/si';
import { FaRobot, FaBrain } from 'react-icons/fa';
const categories = [
  {
    title: 'Frontend & Mobile',
    color: 'from-violet-500 to-purple-600',
    skills: [
      { name: 'HTML5', icon: <FaHtml5 className="text-orange-500" />, level: 90 },
      { name: 'CSS3', icon: <FaCss3Alt className="text-blue-500" />, level: 85 },
      { name: 'JavaScript', icon: <FaJs className="text-yellow-400" />, level: 82 },
      { name: 'React.js', icon: <FaReact className="text-cyan-400" />, level: 85 },
      { name: 'React Native', icon: <FaMobile className="text-cyan-300" />, level: 75 },
      { name: 'Bootstrap', icon: <FaBootstrap className="text-purple-500" />, level: 80 },
      { name: 'Tailwind CSS', icon: <SiTailwindcss className="text-cyan-400" />, level: 78 },
    ],
  },
  {
    title: 'Backend & Database',
    color: 'from-cyan-500 to-blue-600',
    skills: [
      { name: '.ASP.NET Core', icon: <SiDotnet className="text-purple-400" />, level: 75 },
      { name: 'Python', icon: <FaPython className="text-yellow-400" />, level: 75 },
      { name: 'Node.js', icon: <FaNodeJs className="text-green-500" />, level: 72 },
      { name: 'SQL Server', icon: <FaCode className="text-red-400" />, level: 80 },
      { name: 'MySQL', icon: <SiMysql className="text-blue-400" />, level: 78 },
      { name: 'MongoDB', icon: <SiMongodb className="text-green-400" />, level: 70 },
    ],
  },
  {
    title: 'Tools & Others',
    color: 'from-pink-500 to-rose-600',
    skills: [
      { name: 'Git', icon: <FaGitAlt className="text-orange-500" />, level: 85 },
      { name: 'GitHub', icon: <FaGithub className="text-white" />, level: 85 },
      { name: 'GitLab', icon: <SiGitlab className="text-orange-400" />, level: 78 },
      { name: 'Postman', icon: <SiPostman className="text-orange-500" />, level: 82 },
      { name: 'Swagger', icon: <SiSwagger className="text-green-400" />, level: 78 },
      { name: 'VS Code', icon: <FaCode className="text-blue-400" />, level: 90 },
    ],
  },
  {
    title: 'AI Tools & IDEs',
    color: 'from-emerald-500 to-teal-600',
    skills: [
      { name: 'Claude AI', icon: <SiAnthropic className="text-orange-400" />, level: 85 },
      { name: 'ChatGPT', icon: <SiOpenai className="text-green-400" />, level: 85 },
      { name: 'Cursor', icon: <FaCode className="text-blue-400" />, level: 80 },
      { name: 'GitHub Copilot', icon: <FaGithub className="text-white" />, level: 78 },
      { name: 'Antigravity IDE', icon: <FaRobot className="text-violet-400" />, level: 75 },
      { name: 'Kiro IDE', icon: <FaRobot className="text-yellow-400" />, level: 75 },
      { name: 'Prompt Engineering', icon: <FaBrain className="text-pink-400" />, level: 80 },
    ],
  },
];

function SkillBar({ name, icon, level }) {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-300">
          <span className="text-lg">{icon}</span>
          {name}
        </div>
        <span className="text-xs text-slate-500">{level}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{
            width: `${level}%`,
            background: 'linear-gradient(90deg,#7c3aed,#06b6d4)',
            transition: 'width 1s ease',
          }}
        />
      </div>
    </div>
  );
}

export default function Skills() {
  return (
    <section id="skills" className="relative py-24 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.8) 1px, transparent 1px)',
          backgroundSize: '30px 30px',
        }}
      />
      <div className="glow-orb w-80 h-80 bg-cyan-500 bottom-0 -left-20" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
        <div className="text-center mb-12 scroll-animate">

          <h2 className="section-title gradient-text">Skills & Technologies</h2>
          <div className="title-line" />
          <p className="section-subtitle">Technologies I've been working with recently</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((cat, i) => (
            <div
              key={cat.title}
              className={`glass-card p-6 scroll-animate`}
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              <div className="flex items-center gap-3 mb-6">
                <div className={`w-1 h-8 rounded-full bg-gradient-to-b ${cat.color}`} />
                <h3 className="text-lg font-bold text-white">{cat.title}</h3>
              </div>
              {cat.skills.map(skill => (
                <SkillBar key={skill.name} {...skill} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
